import { ArrowsDownUpIcon } from '@phosphor-icons/react'
import { BandPicker, type BandOption } from './BandPicker'

const SORT_ICON = <ArrowsDownUpIcon size={16} />

/**
 * A board's sort, at the right end of its controls row. That end sits outside the toolbar
 * container the band labels measure, so on a phone it drops to its icon by breakpoint instead:
 * otherwise its label pushes the view switch onto a line of its own.
 */
export function SortPicker<T>({
  options,
  value,
  onSelect,
}: {
  options: BandOption<T>[]
  value: T
  onSelect: (id: T) => void
}) {
  return (
    <BandPicker
      noun="Sort"
      menuLabel="Sort by"
      icon={SORT_ICON}
      options={options}
      value={value}
      onSelect={onSelect}
      triggerClassName="max-md:px-2 max-md:[&>:not(:first-child)]:hidden"
    />
  )
}
